import { api, handleResponse, handleError } from "./apiServices";

export const getAllUsers = (token, data) =>
  api(token)
    .post(`/api/user/userRoutes/getAllUsers`, data)
    .then(handleResponse)
    .catch(handleError);

export const getAllMerchants = (token, data) =>
  api(token)
    .post(`/api/user/userRoutes/getAllMerchants`, data)
    .then(handleResponse)
    .catch(handleError);

export const getAllUserMerchants = (token, data) =>
  api(token)
    .post(`/api/user/userRoutes/getAllUserMerchants`, data)
    .then(handleResponse)
    .catch(handleError);

export const getSubUsers = (token, id, query) =>
  api(token)
    .get(`/api/user/auth/get-users/${id}`, query)
    .then(handleResponse)
    .catch(handleError);
export const addSubUser = (token, data) =>
  api(token)
    .post(`/api/user/auth/create`, data)
    .then(handleResponse)
    .catch(handleError);
export const editSubUser = (token, id, data) =>
  api(token)
    .patch(`/api/user/auth/edit/${id}`, data)
    .then(handleResponse)
    .catch(handleError);
export const deleteSubUser = (token, id, data) =>
  api(token)
    .post(`/api/user/auth/delete/${id}`, data)
    .then(handleResponse)
    .catch(handleError);
export const updateUserStatus = (token, id, data) =>
  api(token)
    .patch(`/api/user/auth/updateStatus/${id}`, data)
    .then(handleResponse)
    .catch(handleError);

export const getAllDashboardAnalytics = (token, data) =>
  api(token)
    .post(`/api/user/userRoutes/getAllDashboardAnalytics`, data)
    .then(handleResponse)
    .catch(handleError);

export const getAllSubscriptionHistory = (token, data) =>
  api(token)
    .post(`/api/user/userRoutes/getAllSubscriptionHistory`, data)
    .then(handleResponse)
    .catch(handleError);

export const getCallLogByUserId = (token, id, data) =>
  api(token)
    .post(`/api/callLogs/callLogscrud/getCallLogByUserId/${id}`, data)
    .then(handleResponse)
    .catch(handleError);

export const getAllMerchantDashboardAnalytics = (token, id) =>
  api(token)
    .post(`/api/user/userRoutes/getAllMerchantDashboardAnalytics/${id}`)
    .then(handleResponse)
    .catch(handleError);
